import ApiClient from '../ApiClient';

class CampaignBatchesAPI extends ApiClient {
    constructor() {
        super('crm/campaign_batches', { accountScoped: true });
    }

    populateFromDeals(batchId, filters) {
        return axios.post(`${this.url}/${batchId}/populate_from_deals`, filters);
    }

    populateFromSegment(batchId, segmentFilters) {
        return axios.post(`${this.url}/${batchId}/populate_from_segment`, {
            segment_filters: segmentFilters,
        });
    }

    importCsv(batchId, file, nameColumn = 'name', phoneColumn = 'phone_number') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name_column', nameColumn);
        formData.append('phone_column', phoneColumn);

        return axios.post(`${this.url}/${batchId}/import_csv`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    getContacts(batchId, page = 1, perPage = 25) {
        return axios.get(`${this.url}/${batchId}/contacts`, {
            params: { page, per_page: perPage },
        });
    }

    removeContact(batchId, contactId) {
        return axios.delete(`${this.url}/${batchId}/remove_contact`, {
            params: { contact_id: contactId },
        });
    }

    sendBatch(batchId) {
        return axios.post(`${this.url}/${batchId}/send_batch`);
    }
}

export default new CampaignBatchesAPI();
